import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import VenueListing from 'views/admin/venue/VenueListing'

import VenueForm from 'views/admin/venue/VenueForm'

const Venue = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <VenueListing />
      </Route>
      <Route path={`${path}/new`}>
        <VenueForm displayContext="page" />
      </Route>
      <Route path={`${path}/edit/:venueId`}>
        <VenueForm displayContext="page" />
      </Route>
    </Switch>
  )
}

export default Venue
